import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { times } from 'lodash';
import { UserService } from '../../shared/users.service';

interface UsersList {
  docId: string;
  email: string;
}
@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
})
export class UsersListComponent implements OnInit {
  userInfo: UsersList[] = [];
  dataSource = new MatTableDataSource<UsersList>(this.userInfo);
  displayedColumns = ['userDocId', 'userName'];
  buyersEmail: { [docId: string]: UsersList } = {};
  isNoRec = false;
  isLoader = true;
  livestreamPrice = '';
  vodPrice = '';
  bundlePrice = '';

  constructor(
    private readonly userService: UserService,
    @Inject(MAT_DIALOG_DATA)
    public data: { header: string; userDocIds: string[] },
  ) {
    times(2, () =>
      this.userInfo.push({
        docId: '',
        email: '',
      }),
    );
  }

  async ngOnInit(): Promise<void> {
    this.userInfo = await this.getEmail(this.data.userDocIds);
    this.isLoader = false;
    this.dataSource = new MatTableDataSource(this.userInfo);
  }
  async getEmail(userDocIds: string[]) {
    const userDocs = await this.userService.getUsersByBatch(userDocIds);
    return userDocs.map((item) => ({
      docId: item.docId || '',
      email: item.email || 'N/A',
    }));
  }
}
